// common regex expressions should go here

export const emailRegex = /\S+@\S+\.\S+/;
export const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
export const moneyRegex = /[$£]([0-9]+\.[0-9][0-9])?/;
